import React from "react";
import PageHeader from "../../../../components/Common/PageHeader";

function GridHeader() {
  return <PageHeader title="Editar rota" />;
}

export default GridHeader;